import React from "react";
import { PrivateRoutesProps } from "./PrivateRoutesProps";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";

const PrivateRoutes: React.FC<PrivateRoutesProps> = ({
  element,
  requiredRole,
}) => {
  const { isAuthenticated, isAuthLoading, userDetails } = useAuth();
  const location = useLocation();

  const hasRequiredRole = (): boolean => {
    if (!requiredRole) {
      return true;
    }

    if (!userDetails) {
      return false;
    }

    if (userDetails.role_name === "Admin") {
      return true;
    }

    const requiredRoles = Array.isArray(requiredRole)
      ? requiredRole
      : [requiredRole];

    const hasAccess = requiredRoles.includes(userDetails.role_name);

    return hasAccess;
  };

  // Wait for persisted auth to be restored before deciding — otherwise a page
  // reload (e.g. from the Bhashini widget) would momentarily see "logged out"
  // and redirect away from the current route.
  if (isAuthLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!hasRequiredRole()) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  return element;
};

export default PrivateRoutes;
